import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

export const postFindMyOrder = async (formData: {
	orderNumber: string;
	email: string;
}): Promise<AxiosResponse> => {
	const response = await api.post('/commerce/orders/find-my-order', {
		orderNumber: formData.orderNumber,
		guestEmail: formData.email,
	});

	return response;
};
